import {
  FlexBox,
  Icon,
  NavigationButton,
  Table,
  Text,
} from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

import { CustomForm } from '../../../../../customForms.types';

export function FormUsageRows({
  usage,
}: {
  usage: CustomForm['usage'];
}): JSX.Element {
  const navigate = useAppNavigate();

  const goToFlow = useCallback(
    (flowId: string) => {
      // It is assumed that in the first iteration that the forms is only used in messenger flows.
      navigate({
        path: '/settings/dixa-messenger/flow/:flowId',
        params: { path: { flowId } },
      });
    },
    [navigate],
  );

  const emptyState = (
    <Table.Tr>
      <Table.Td>
        <Text.Paragraph variant="2">
          This form is not used in any flows
        </Text.Paragraph>
      </Table.Td>
    </Table.Tr>
  );

  return (
    <Table framed={false}>
      <Table.Tbody>
        {usage.length === 0 && emptyState}

        {usage.map(({ flowId, flowTitle }, index) => (
          <Table.Tr key={`${flowId}-${index}`}>
            <Table.Td>
              <FlexBox alignItems="center" gap="200">
                <Icon name="chat" /> {flowTitle}{' '}
                <NavigationButton navigate={() => goToFlow(flowId)}>
                  Go to flow
                </NavigationButton>
              </FlexBox>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
